module.exports = __webpack_public_path__ + "img/couples-039.6650b16d.jpg";